<template>
  <div>
    <h2>Undealt instructions</h2>
    <table class="diary">
      <tr>
        <th>Quote id</th>
        <th>Name</th>
        <th>Ip address</th>
        <th>Username</th>
        <th>Date</th>
      </tr>
      <tr v-for="quote in computedQuotes" :key="quote.id">
        <td>
          <QuoteZ :quote="quote" />
        </td>
        <td>{{quote.name}}</td>
        <td>{{quote.ipaddress}}</td>
        <td>
          <EntityZ :entity="quote.user" v-if="quote.user" />
          <span v-if="!quote.user">{{quote.userid}}</span>
        </td>
        <td>{{quote.timestamp | formatDateTime}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import QuoteZ from "@/components/link/QuoteZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Undealt",
  metaInfo() {
    return {
      title: "Undealt",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityZ, QuoteZ },
  computed: {
    computedQuotes() {
      if (!this.quotes) {
        return undefined;
      }
      return this.quotes.map(q => {
        const user = this.entities ? this.entities[q.userid] : undefined;
        return { ...q, user };
      });
    }
  },
  data() {
    return { quotes: null, entities: null };
  },
  methods: {
    fetchQuotes() {
      nbmlaw
        .get(`/cors/admin/sales/quotes/undealt`)
        .then(response => {
          // console.log(response.data);
          this.quotes = response.data;
        })
        .catch(() => {});
    },
    fetchEntities() {
      nbmlaw
        .get(`/cors/admin/sales/quotes/undealt/users`)
        .then(response => {
          // console.log(response.data);
          this.entities = response.data;
        })
        .catch(() => {});
    }
  },
  created() {
    this.fetchQuotes();
    this.fetchEntities();
  }
};
</script>